import { getDiscriminatedDatum } from "../discrimination/getDiscriminatedDatum.js";
const getDiscriminatedBlock = (blocks, field) => getDiscriminatedDatum(blocks, field);
export {
  getDiscriminatedBlock
};
//# sourceMappingURL=getDiscriminatedBlock.js.map
